<template>
	<section class="advice">
		<div class="content">
			<component
				v-for="(module, n) in currentPage.modules"
				:key="`module_${module.type}_${n}`"
				:is="module.type"
				v-bind="module"
			></component>
		</div>
		<button
			class="back"
			type="button"
			@click="() => this.$router.push(`${redirectLang}`)"
			@mouseenter="onPointerMouseEnter"
			@mouseleave="onPointerMouseLeave"
		>
			<IconArrow fill="#000" />
			<span>HOME</span>
		</button>
	</section>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import IconArrow from "@/components/icons/IconArrow";
import PointerHoverMixin from "@/mixins/pointerHover";
import EventBus from "@/helpers/event-bus";

export default {
	name: "AdviceView",
	mixins: [PointerHoverMixin],
	components: {
		IconArrow,
	},
	props: {
		slug: String,
	},
	computed: {
		...mapState({
			currentLanguage: (state) => state.site.currentLanguage,
			defaultLanguage: (state) => state.site.defaultLanguage,
		}),
		...mapGetters("page", ["currentPage"]),
		redirectLang() {
			return this.currentLanguage === this.defaultLanguage
				? "/"
				: `/${this.currentLanguage}`;
		},
		title() {
			return this.currentPage.seotitle;
		},
	},
	metaInfo() {
		return {
			title: this.title,
		};
	},
	watch: {
		currentPage() {
			EventBus.$emit(EventBus.page.loaded);
		},
	},
};
</script>

<style lang="scss" scoped>
$time: 0.4s;
@keyframes border1 {
	0% {
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
		// transform: scale(1)
	}

	33% {
		border-radius: 80% 70% 80% 70% / 80% 70% 100% 70%;
		// transform: scale(1.2)
	}

	66% {
		border-radius: 100% 50% 70% 90% / 90% 100% 60% 80%;
		// transform: scale(1.4)
	}

	100% {
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
	}
}

.advice {
	@include mq($to: m) {
		padding-top: 50px;
	}

	.content {
		& > * {
			@include mq($from: m) {
				@include gridColumn(m, 23, 1, false, true);
			}

			@include mq($from: xl) {
				@include gridColumn(xl, 13, 2, false, true);
			}
		}
	}

	button {
		border: 0;
		background: #fff;
		box-shadow: none;
		appearance: none;
		-webkit-appearance: none;
		width: 65px;
		height: 62px;
		border-radius: 50% 100% 70% 60% / 80% 70% 80% 60%;
		position: fixed;
		top: 65px;
		left: 10vw;
		z-index: 11;
		outline: none;
		cursor: pointer;
		transition: background $time, transform $time, opacity $time;
		animation: border1 2s infinite linear;
		animation-play-state: paused;
		transform: translateY(-40px);
		display: flex;
		align-items: center;
		justify-content: center;

		@include mq($from: m) {
			top: 90px;
			left: 72.5vw;
		}

		@include mq($from: l) {
			top: 70px;
			left: 72.5vw;
			width: 100px;
			height: 95px;
		}

		@include mq($from: xl) {
			top: 120px;
			left: 72.5vw;
		}

		@include mq($from: 2830px) {
			left: 72.5vw;
		}

		span {
			@include fontMenu;
			transition: color $time;
			font-size: 12px !important;
			margin: 0 0 0 10px !important;
		}

		&::v-deep {
			svg {
				transform: rotate(180deg);
			}

			svg path {
				transition: all $time;
			}
		}

		&:hover {
			animation-play-state: running;
			background: $colorRed1;

			span {
				color: #fff;
			}

			&::v-deep {
				svg path {
					fill: #fff;
				}
			}
		}
	}
}
</style>
